import { render, staticRenderFns } from "./MealPlanner.vue?vue&type=template&id=543dfcf1&scoped=true"
import script from "./MealPlanner.vue?vue&type=script&lang=js"
export * from "./MealPlanner.vue?vue&type=script&lang=js"
import style0 from "./MealPlanner.vue?vue&type=style&index=0&id=543dfcf1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543dfcf1",
  null
  
)

export default component.exports